import { render, staticRenderFns } from "./ProfitLoss.vue?vue&type=template&id=a0fc1cbc"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./ProfitLoss.vue?vue&type=style&index=0&id=a0fc1cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports